import { render, staticRenderFns } from "./summarizedspoken.vue?vue&type=template&id=5f7b536e&"
import script from "./summarizedspoken.vue?vue&type=script&lang=js&"
export * from "./summarizedspoken.vue?vue&type=script&lang=js&"
import style0 from "./summarizedspoken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports